import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

import { APP_ROUTES } from "../../constants/appRoutes";
import FullWidthLayout from "../shared/FullWidthLayout";

export default function PaymentFailed() {
    return (
        <FullWidthLayout>
            <div className="mx-auto w-full max-w-lg py-8 md:py-14">
                <article className="w-full rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_8px_30px_rgba(15,23,42,0.08)] sm:p-6 md:p-8">
                    <div className="mb-6 flex flex-col items-center text-center">
                        <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full border border-red-200 bg-red-50 shadow-sm">
                            <i className="bi bi-x-lg text-5xl text-red-600" aria-hidden />
                        </div>
                        <p className="my-4 text-lg font-bold uppercase tracking-[0.18em] text-red-700">
                            Payment failed
                        </p>
                        <h1 className="mb-2 text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
                            Payment not completed
                        </h1>
                        <p className="mb-0 max-w-sm text-sm leading-relaxed text-slate-600">
                            Your payment was not processed. No charges were made. You can try again
                            or return home.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        <Link
                            to={APP_ROUTES.HOME}
                            className="btn btn-dark-outline-app flex w-full items-center justify-center gap-2 no-underline"
                        >
                            <i className="bi bi-house-door" aria-hidden />
                            Home
                        </Link>
                        <Link
                            to={APP_ROUTES.PLANS}
                            className="btn btn-dark-app flex w-full items-center justify-center gap-2 no-underline"
                        >
                            <i className="bi bi-credit-card" aria-hidden />
                            View plans
                        </Link>
                    </div>
                </article>
            </div>
        </FullWidthLayout>
    );
}
